// 图片元素的覆层组件
import React, { useCallback } from 'react';
import { Icon } from '@shakkerai/components';
import { downloadImage } from '@shakkerai/pro-utils';
import { translate } from '@shakkerai/util-i18n';
import { playVideo } from '@starflow/app/helpers/video';

export const VideoOverlayerInner = ({ isExactlySelected, element }) => {
  const handlePlayVideo = useCallback(() => {
    playVideo(element);
  }, [element]);

  const handleDownloadVideo = useCallback(() => {
    downloadImage(element.url || element.videoUrl, false);
  }, [element]);

  if (!isExactlySelected) return null;

  return (
    <>
      <div className="absolute z-1 right-3 w-6 h-6 top-2 flex items-center bg-black/70 rounded-[3px] text-caption-500 text-xs pointer-events-auto">
        <button onClick={handleDownloadVideo} className={`flex items-center justify-center w-6 h-6 font-normal`}>
          <Icon className="shk-image_Download" color="#fff" fontSize={16} />
        </button>
      </div>
      <div className="absolute top-full left-1/2 -translate-x-1/2">
        <div className="flex items-center mt-2 bg-white shadow-light rounded-sm pointer-events-auto">
          <button
            onClick={handlePlayVideo}
            className={`flex items-center justify-center h-8 font-normal text-[#2c2c2c] px-2 py-3`}
          >
            <div className="flex items-center justify-center w-4 h-4">
              <Icon className="shk-danchuang-yunhangliang" color="inherit" fontSize={16} />
            </div>
            <span className="ml-1 whitespace-nowrap text-xs">{translate('播放视频')}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export const VideoOverlayer = React.memo((props) => {
  const { isExactlySelected, isHovering, isMiniMode } = props;

  return (
    <VideoOverlayerInner
      {...props}
      isMiniMode={isMiniMode}
      isHovering={isHovering}
      isExactlySelected={isExactlySelected}
    />
  );
});
